module.exports = __webpack_public_path__ + "img/reservation_gift2.f9254156.png";